/* import { getDefaultConfig } from "@rainbow-me/rainbowkit"; */
import { createConfig } from "wagmi";
import { http } from "viem";
import { base } from "viem/chains";

export const config = createConfig({
  chains: [base],
  multiInjectedProviderDiscovery: false,
  transports: {
    [base.id]: http(),
    /* `https://base-sepolia.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_KEY}` */
    /* `https://sepolia.base.org` */
  },
});

/* export const config = getDefaultConfig({
  appName: "Rexla App",
  projectId: process.env.REACT_APP_WALLET_PROJECT_ID,
  chains: [base, polygon, optimism, arbitrum, base],
  transports: {
    [sepolia.id]: http(
      `https://eth-sepolia.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_KEY}`
    ),
  },
  // ssr: true, // If your dApp uses server side rendering (SSR)
}); */

export default config;
